// Labels für die 3 Bildungskontexte (+ Alt-Alias aus der Zeit vor
// der Konsolidierung 2026-07-18, siehe docs/format-konsolidierung.md).
// UI-seitig definiert → über i18n-Keys auflösbar (de/en).
import i18n from "@/i18n";

const CONTEXT_KIND_KEYS: Record<string, string> = {
  hochschule: "contexts.hochschule",
  ausbildung: "contexts.ausbildung",
  corporate_ld: "contexts.corporate_ld",
  weiterbildung: "contexts.corporate_ld",
};

export function contextKindLabel(value: string | null | undefined): string | null {
  if (!value) return null;
  const key = CONTEXT_KIND_KEYS[value];
  return key ? i18n.t(key) : value;
}
